<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
  min-width: 1366px;
  min-height: 768px;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

  #app /deep/ .el-body{
    height: calc(100% - 90px);
  }
/* 解决elxEditable点击line-height发生改变的问题 */
.elx-editable .elx-editable-column.elx_edit.elx_active .cell{
  line-height: normal;
}
/* a标签下划线以及被访问后颜色的默认项 */
a{
  text-decoration: none;
}

.el-table__header,
.el-table__body{
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue